/** Auto-generated at build time - do not edit */
export const APP_VERSION = "1.6977.0";
